<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                <v-icon class="mr-2">mdi-printer</v-icon>
                Print
              </v-btn>
              <v-btn color="success" class="button-shadow" to="/pricelist/list">
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="12" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width: 100px;"><img v-if="logo!=null" :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td style="width:40%; padding-left: 20px;">
                        <p style="margin-top: 0;margin-bottom: 0;"><span style="white-space: pre; font-size: 9pt; text-alignment: left;">{{ companyaddress }}</span></p>
                      </td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Pricelist Num</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">&nbsp;</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Pricelist Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">&nbsp;</span></td>
                          </tr>
                         </table> 
                      </td>
                    </tr>
                  </table>
                  <div style="padding: 15px;"></div>
                  <table style="width: 100%;">
                    <tr>
                      <td><div align="center"><h3 class="ma-0"><b>{{ initvalue.pricelistname }}</b></h3></div></td>
                    </tr>
                  </table>
                </v-row>
                <div style="padding: 15px;"></div>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 2%;">#</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; width: 30%;">Item</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid; ">Price</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in Object.keys(group_pricelist)"  v-bind:key="trans">
                          <td style="vertical-align: top;border-bottom: 1px; border-bottom-style: solid">{{ index + 1 }}</td>
                          <td style="vertical-align: top; border-bottom: 1px; border-bottom-style: solid">{{ trans }}</td>
                          <td style="text-align: left;vertical-align: top; border-bottom: 1px; border-bottom-style: solid">
                            <table width="100%">
                              <tr v-for="(item) in group_pricelist[trans]" v-bind:key="item._id">
                                <td style="white-space: nowrap; width: 25%;"><span style="font-size: 9pt;">{{ item.pricename }}:</span>  <span style="font-weight: bold">{{ item.listprice }}</span> <span style="font-size: 7pt">{{ item.currency}}</span></td>
                                <td style="padding-left: 10px;  width: 25%;">Qty {{ item.minqty }} - {{ item.maxqty }}</td>
                                <td v-if="item.foc.enable==true" style="padding-left: 10px; text-align: left; width: 50%;">
                                  <span style="font-size: 9pt;">Buy {{ item.foc.itemqty }} Get {{ item.foc.getitemqty }}</span>&nbsp;
                                  <span style="font-size: 9pt;">{{ items.length>0 ? items.find(x=>x._id==item.foc.itemid)['itemsalesdesc'] : '' }}</span>
                                </td>
                                <td v-else style="padding-left: 5px; text-align: left;">&nbsp;</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" style="vertical-align: top;"><strong>Note: </strong>{{ initvalue.pricelistnote }}</td>
                        </tr>
                        
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>,
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo, groupBy, sortDataAsc } from '../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            logo: null,
            companyaddress: '',
            initvalue: {},
            group_pricelist: {},
          };
        },
        computed: {
          ...mapState('Item', ['items']),
          ...mapState('SalesChannel', ['saleschannels']),
        },
        methods: {
          ...mapActions('Item', ['getItemsRequest']),
          ...mapActions('SalesChannel', ['getSalesChannelsRequest']),
          ...mapActions('SystemSetting', ['getSetting']),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,channel=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          },
        },
        async created () {
          this.initvalue = this.$route.params;
          if(!this.initvalue._id) this.$router.push({ name: 'PricelistList' });
          sortDataAsc(this.initvalue.prices, 'pricerank')


          this.group_pricelist = groupBy(this.initvalue.prices, (i)=>i.itemname, 'itemname');
          if(this.items.length==0) await this.getItemsRequest();
          if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
          
          this.logo = getLogo(this.initvalue.companyid);
          this.companyaddress = await this.getSetting({code: 'CompanySettings', name: 'CompanyAddress'}, );
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
